import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Testimonials from '../components/home/Testimonials';
import ServicesBanner from '../components/haseeb/ServicesBanner';
import BannerImg from '../assets/images/testimonials/BannerImage.webp';

const TestimonialsPage = () => {

    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
        return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>software development & digital marketing agency in Germany - IT Junction </title>
    </Helmet>
    </HelmetProvider>
    <Header2/>
            <ServicesBanner
    BannerImg={BannerImg}
    SubTitle="Our Top Priority"
    Title="Client Testimonials"
    />
        <Testimonials/>
        <div className="py-4" />
        </>
    )
}

export default TestimonialsPage